import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Typography,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { ExpandMore } from '@material-ui/icons';
import localforage from 'localforage';
import PropTypes from 'prop-types';
import styles from 'styles/pages/fiches-techniques-brand-model.module.scss';
import { apiQl } from 'lib/functions';
import { urlWriter, getBaseDate } from 'tools/functions';
import SpecsSoeezauto from 'components/specsSoeezauto';
import getBrandsModelsSimple from 'lib/getBrandsModelsSimple';
import { actionGetBrandsModels, actionSetGetBrandsModelsToNull } from 'store/actions';
import Breadcrumb from 'components/breadcrumb';
import PdfViewer from 'components/pdfViewer';

const WidgetNav = dynamic(() => import('../../../../components/widgetNav'), {
    ssr: false,
});

const WidgetLaunches = dynamic(() => import('../../../../components/widgetLaunches'), {
    ssr: false,
});

const WidgetPromo = dynamic(() => import('../../../../components/widgetPromotion'), {
    ssr: false,
});

const FicheTechniqueModel = (props) => {
    const { model, hasSpecs, filePath, dataGetBrandsModels } = props;
    const [brands, setBrands] = useState(null);

    useEffect(() => {
        localforage
            .getItem('brandsModels')
            .then((value) => {
                if (value) {
                    if (value.expire > new Date().getTime()) {
                        setBrands(value.data);
                    } else {
                        localforage.removeItem('brandsModels');
                    }
                } else {
                    props.actionGetBrandsModels();
                }
            })
            .catch(() => {
                props.actionGetBrandsModels();
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (dataGetBrandsModels) {
            setBrands(dataGetBrandsModels);
            const now = new Date();
            localforage.setItem('brandsModels', {
                data: dataGetBrandsModels,
                expire: now.setDate(now.getDate() + 3),
            });
            props.actionSetGetBrandsModelsToNull();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataGetBrandsModels]);

    return (
        <div>
            {model && (
                <Head>
                    <title>
                        {`Fiche technique ${model.brand.brand} ${model.model} neuve au Maroc | soeezauto.ma`}
                    </title>
                    <meta
                        name="description"
                        content={`Fiche technique ${model.brand.brand} ${model.model} neuve au Maroc, guide d'achat, prix, comparateur`}
                    />
                    <meta property="og:type" content="siteweb" />
                    <meta
                        property="og:title"
                        content={`Fiche technique ${model.brand.brand} ${model.model} neuve au Maroc, prix`}
                    />
                    <meta
                        property="og:image"
                        content={`${process.env.NEXT_PUBLIC_API_HOST}/images/models/${model.images[0].filename}`}
                    />
                    <meta
                        property="og:url"
                        content={`${
                            process.env.NEXT_PUBLIC_CLIENT_HOST
                        }/fiches-techniques/${urlWriter(model.brand.brand)}/${urlWriter(
                            model.model,
                        )}`}
                    />
                    <link
                        rel="canonical"
                        href={`${
                            process.env.NEXT_PUBLIC_CLIENT_HOST
                        }/fiches-techniques/${urlWriter(model.brand.brand)}/${urlWriter(
                            model.model,
                        )}`}
                    />
                </Head>
            )}
            <main className={styles.root}>
                <Breadcrumb
                    links={[
                        {
                            href: '/fiches-techniques',
                            text: 'Fiches techniques',
                        },
                        {
                            href: `/fiches-techniques/${urlWriter(model.brand.brand)}`,
                            text: model.brand.brand,
                        },
                        {
                            href: null,
                            text: model.model,
                        },
                    ]}
                />
                <div className="main-title">
                    <h1>{`Fiche technique & prix - ${model.brand.brand} ${model.model}`}</h1>
                </div>
                <div className={styles.ftbrand}>
                    <Accordion
                        TransitionProps={{ unmountOnExit: true }}
                        className={styles.accordionRoot}
                    >
                        <AccordionSummary
                            expandIcon={<ExpandMore />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography className={styles.fttitle}>
                                Fiche technique de la marque
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails className={styles.accordionDetails}>
                            {hasSpecs ? (
                                <div className={styles.currentModel}>
                                    <div className={styles.iframeContainer}>
                                        {/* https://stackoverflow.com/questions/19654577/html-embedded-pdf-iframe 
                        {filePath && (
                            <object
                                className={styles.responsiveIframe}
                                data={filePath}
                                type="application/pdf"
                            >
                                <iframe
                                    className={styles.responsiveIframe}
                                    src={`https://docs.google.com/viewer?url=${filePath}&embedded=true`}
                                    title={currentModel.specs.edges[0].node.filename}
                                />
                            </object>
                        )}
                        */}
                                        {filePath && <PdfViewer filePath={filePath} />}
                                        {/* <iframe
                            className={styles.responsiveIframe}
                            title={currentModel.specs.edges[0].node.filename}
                            // style={{ width: '100%', height: 1500 }}
                            src={filePath}
                        /> */}
                                    </div>
                                </div>
                            ) : (
                                <Alert
                                    style={{
                                        maxWidth: 500,
                                        margin: '0 auto',
                                        textAlign: 'left',
                                    }}
                                    severity="info"
                                    variant="filled"
                                >
                                    Aucune fiche technique du constructeur disponible à ce
                                    moment. Nous travaillons pour en ajouter.
                                </Alert>
                            )}
                        </AccordionDetails>
                    </Accordion>
                </div>
                <SpecsSoeezauto model={model} />
                {brands && (
                    <>
                        <WidgetPromo data={brands} />
                        <WidgetNav brands={brands} />
                        <WidgetLaunches data={brands} />
                    </>
                )}
            </main>
        </div>
    );
};

FicheTechniqueModel.propTypes = {
    model: PropTypes.object.isRequired,
    actionGetBrandsModels: PropTypes.func.isRequired,
    actionSetGetBrandsModelsToNull: PropTypes.func.isRequired,
    dataGetBrandsModels: PropTypes.any,
};

const mapStateToProps = (state) => {
    return {
        dataGetBrandsModels: state.brand.dataGetBrandsModels,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            actionGetBrandsModels,
            actionSetGetBrandsModelsToNull,
        },
        dispatch,
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(FicheTechniqueModel);

// const queryQlModelSpecs = `query getModelSpecs(
//   	$model: [String!]
//     $after: String!
// ) {
//         models(
//             model_list: $model
//             isActive: true
//             _order: {model: "ASC"}
//         ) {
//             id
//             model
//             modelYear
//             brand {
//                 brand
//             }
//             images(isFeatured: true) {
//                 filename
//             }
//             specs(
//                 first: 1, after: null,
//               	_order: {updatedAt: "DESC"}
//               	updatedAt: {after: $after}
//             ) {
//                 edges {
//                     node {
//                         filename
//                         updatedAt
//                     }
//                 }
//             }
//         }
// }`;

const queryQlModel = `query getModel(
  	$model: [String!]
    $after: String!
) {
        models(
            model_list: $model
            isActive: true
            _order: {model: "ASC"}
        ) {
            id
            model
            modelYear
            brand {
                id
                brand
                image
            }
            images(isFeatured: true) {
                filename
            }
            specs(
                first: 1, after: null,
              	_order: {updatedAt: "DESC"}
              	updatedAt: {after: $after}
            ) {
                edges {
                    node {
                        filename
                        updatedAt
                    }
                }
            }
            versions(
                isActive: true
                _order:{ bodyType: "ASC", motor_fuel: "ASC", prices_price: "ASC"}
            ){
                id
                version
                gearbox
                places
                doors
                curbWeight
                gvw
                traction
                tyreFront {
                    tyre
                }
                tyreBack {
                    tyre
                }
                prices(
                    _order: {createdAt: "DESC"}
                ) {
                    edges {
                        node {
                            id
                            createdAt
                            price
                            promo
                        }
                    }
                }
                CF {
                    CF
                }
                motor {
                    power
                    fuel
                    cc
                    cylinder
                    torque
                    valves
                    aspiration
                }
                measures {
                    fuelTank
                    width
                    height
                    length
                    wheelbase
                    trunk
                    trunkMax
                }
                performance {
                    to100
                    maxSpeed
                    emissions
                    mileageCity
                    mileageRoad
                    mileageMix
                }
            }
        }
}`;

export async function getStaticPaths() {
    let brands = await getBrandsModelsSimple();
    brands = brands.data.brands;
    const paths = [];
    brands.forEach((brand) => {
        brand.models.forEach((model) => {
            paths.push({
                params: {
                    brand: urlWriter(brand.brand),
                    model: urlWriter(model.model),
                },
            });
        });
    });
    return {
        paths,
        fallback: false,
    };
}

export async function getStaticProps({ params }) {
    const { model: modelParam, brand: brandParam } = params;
    let t = 0;
    const variables = {
        model: [
            modelParam,
            modelParam.replace(/-/g, ' '),
            modelParam.replace(/-/g, (match) => (++t === 2 ? ' ' : match)), // this to accommodate e-tron Sportback
        ],
        after: getBaseDate(90),
    };
    const data = await apiQl(queryQlModel, variables, false);
    if (data.data.models.length === 0) {
        return {
            notFound: true,
        };
    }
    const modelFilter = data.data.models.filter((mod) => {
        return (
            mod.model.toLowerCase().replace(/-/g, ' ') ===
                modelParam.replace(/-/g, ' ') &&
            mod.brand.brand.toLowerCase() === brandParam.toLowerCase().replace(/-/g, ' ')
        );
    });
    const model = modelFilter[0];
    const hasSpecs = model.specs.edges.length > 0;
    const filePath = hasSpecs
        ? `${process.env.NEXT_PUBLIC_API_HOST}/specs/${urlWriter(
              model.brand.brand,
          )}/${new Date(model.specs.edges[0].node.updatedAt).getFullYear()}/${(
              new Date(model.specs.edges[0].node.updatedAt).getMonth() + 1
          )
              .toString()
              .padStart(2, '0')}/${model.specs.edges[0].node.filename}`
        : null;
    return {
        props: {
            model,
            hasSpecs,
            filePath,
        },
    };
}
